// Esqueletos de carregamento.
//
// Um spinner centralizado diz "espere" e nada mais; o esqueleto já mostra a
// forma da página, então o conteúdo real "preenche" o que você estava olhando
// em vez de substituir uma tela vazia. A diferença aparece principalmente na
// referência, onde o spec do backend passa de 350 KB.
//
// Todos os blocos são aria-hidden e o container carrega o aria-busy — para um
// leitor de tela, barras cinzas não são informação.

const Bar = ({ w = "100%", h = 13, mt = 0 }) => (
  <div className="sk-bar" style={{ width: w, height: h, marginTop: mt }} />
);

export function ProseSkeleton() {
  return (
    <div className="sk" aria-busy="true" aria-live="polite">
      <Bar w="88px" h={10} />
      <Bar w="62%" h={34} mt={14} />
      <Bar w="100%" h={15} mt={20} />
      <Bar w="94%" h={15} mt={8} />
      <Bar w="71%" h={15} mt={8} />

      <Bar w="34%" h={20} mt={38} />
      <div className="sk-block" style={{ marginTop: 16, height: 108 }} />

      <Bar w="100%" h={15} mt={26} />
      <Bar w="83%" h={15} mt={8} />
      <Bar w="90%" h={15} mt={8} />
      <Bar w="45%" h={15} mt={8} />

      <Bar w="28%" h={20} mt={38} />
      <Bar w="96%" h={15} mt={18} />
      <Bar w="76%" h={15} mt={8} />
    </div>
  );
}

// Espelha o layout de <Reference>: título, base URL e endpoints em duas colunas.
export function ReferenceSkeleton({ endpoints = 3 }) {
  return (
    <div className="sk" aria-busy="true" aria-live="polite">
      <Bar w="104px" h={10} />
      <Bar w="46%" h={34} mt={14} />
      <Bar w="100%" h={15} mt={20} />
      <Bar w="68%" h={15} mt={8} />
      <div className="sk-block" style={{ marginTop: 24, height: 38, width: 290, borderRadius: 8 }} />

      {Array.from({ length: endpoints }, (_, i) => (
        <div key={i} className="sk-endpoint">
          <div className="sk-endpoint-head">
            <div className="sk-bar sk-method" />
            <Bar w={`${180 + ((i * 47) % 130)}px`} h={15} />
          </div>
          <div className="sk-endpoint-grid">
            <div>
              <Bar w="52%" h={15} />
              <Bar w="100%" h={13} mt={12} />
              <Bar w="86%" h={13} mt={7} />
              <Bar w="74px" h={10} mt={22} />
              <div className="sk-block" style={{ marginTop: 10, height: 76 }} />
            </div>
            {/* O painel da direita é escuro na tela real. */}
            <div className="sk-block sk-panel" style={{ height: 230 }} />
          </div>
        </div>
      ))}
    </div>
  );
}

export default ProseSkeleton;
